module.exports = "fonts/libre-baskerville-v5-latin-regular.woff2";